import { ReactElement } from 'react';
import { TotalItem } from 'devextreme-react/data-grid';
import React from 'react';
import { conditionalTwoDigitSummaryCurrency } from './constants/constants';

interface IDrawAutomaticTotalItemsProps {
    drawId: number;
    drawNumber: number;
    drawFinalized: boolean;
    toggleArray: [];
}

export const DrawAutomaticTotalItems = ({
    drawId,
    drawNumber,
    drawFinalized,
    toggleArray,
}: IDrawAutomaticTotalItemsProps): ReactElement[] => {
    if (toggleArray[drawNumber] === true) {
        return [
            <TotalItem
                name={`drawItems-inspection-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-inspection-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
            <TotalItem
                name={`drawItems-funded-${drawId}-${drawNumber}`}
                showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                summaryType='custom'
                customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            />,
            // <TotalItem
            //     name={`Accommodation${drawId}-${drawNumber}`}
            //     showInColumn={`Accommodation${drawId}-${drawNumber}`}
            //     summaryType='custom'
            //     customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
            // />,
        ];
    } else {
        if (drawFinalized) {
            return [
                <TotalItem
                    name={`drawItems-funded-${drawId}-${drawNumber}`}
                    showInColumn={`drawItems-funded-${drawId}-${drawNumber}`}
                    summaryType='custom'
                    customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
                />,
            ];
        } else {
            return [
                <TotalItem
                    name={`drawItems-inspection-${drawId}-${drawNumber}`}
                    showInColumn={`drawItems-inspection-${drawId}-${drawNumber}`}
                    summaryType='custom'
                    customizeText={(data) => conditionalTwoDigitSummaryCurrency(data)}
                />,
            ];
        }
    }
};
